import React from 'react';
import { Home } from 'lucide-react';

export default function NotFound({ onNavigate }) {
    return React.createElement('div', {
        style: {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '20px',
            animation: 'fadeIn 0.5s ease-out',
            color: 'var(--text-primary)'
        }
    },
        // Mascot Image
        React.createElement('img', {
            src: "/images/mascots/BitGlitch.png",
            alt: "BitGlitch 404 Mascot",
            style: {
                maxWidth: '300px',
                height: 'auto',
                marginBottom: '30px',
                filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.2))'
            },
            onError: (e) => {
                // Fallback if user hasn't uploaded mascot yet
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
            }
        }),

        // Fallback Text (Hidden if image loads)
        React.createElement('div', {
            style: { fontSize: '80px', marginBottom: '10px', display: 'none' }
        }, "🛸"),

        React.createElement('h1', {
            style: {
                fontSize: '48px',
                fontWeight: '800',
                background: 'linear-gradient(135deg, var(--primary) 0%, #ec4899 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                marginBottom: '10px'
            }
        }, "404"),

        React.createElement('h2', {
            style: { fontSize: '24px', marginBottom: '20px', color: 'var(--text-secondary)' }
        }, "Lost in Space?"),

        React.createElement('p', {
            style: { maxWidth: '400px', marginBottom: '40px', lineHeight: '1.6', color: 'var(--text-muted)' }
        }, "The page you're looking for seems to have drifted into a black hole. Don't worry, even the best explorers get lost sometimes!"),

        React.createElement('button', {
            onClick: () => onNavigate('feed'),
            className: "btn-primary",
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 30px',
                fontSize: '18px'
            }
        },
            React.createElement(Home, { size: 20 }),
            "Return Home"
        )
    );
}
